import CircleIcon from "@mui/icons-material/Brightness1";
import { Box, Chip, Step, StepLabel, Stepper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ActiveChargedOffSlider from "../../unit/loanslider/ActiveChargedOffSlider";
import ActiveLateSlider from "../../unit/loanslider/ActiveLateSlider";
import ActiveOKSlider from "../../unit/loanslider/ActiveOKSlider";
import ActivePaidOffSlider from "../../unit/loanslider/ActivePaidOffSlider";
import ActiveVoidedSlider from "../../unit/loanslider/ActiveVoidedSlider";

const CustomSlider = ({ ...props }) => {
  const value = props.value;
  const marks = props.marks;
  const beforeColor = "red";
  const afterColor = props.afterColor;
  const displyThumb = false;

  return (
    <ActiveOKSlider
      valueLabelDisplay="auto"
      aria-label="pretto slider"
      aria-labelledby="non-linear-slider"
      value={value}
      min={0}
      step={1}
      max={100}
      marks={marks}
    />
  );
};

const steps = ["Active", "30D", "Late", "Paid-Off", "Charged-Off", "Voided"];
function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;
  if (completed || active) {
    return <CircleIcon color="primary" sx={{ size: 2 }} />;
  } else {
    return <CircleIcon color="disabled" />;
  }
}

function valuetext(value: number) {
  return `${value}%`;
}
const LoanStatusSteps = ({ ...props }) => {
  let { activeStatus, activePaid } = props;
  let activeStatus2 = activeStatus;
  let steplist = steps;
  let marks = [];
  if (activePaid == 0) {
    marks = [
      {
        value: 0,
        label: "0%",
      },
    ];
  } else if (activePaid == 100) {
    marks = [
      {
        value: 100,
        label: "100%",
      },
    ];
  } else {
    if (activePaid == 0) {
      marks = [
        {
          value: 0,
          label: "0%",
        },
      ];
    } else {
      marks = [
        {
          value: activePaid,
          label: activePaid + "%",
        },
      ];
    }
  }
  if (
    activeStatus2 == "30D" ||
    activeStatus2 == "60D" ||
    activeStatus2 == "90D" ||
    activeStatus2 == "120D"
  ) {
    activeStatus2 = "Late";
  }
  // alert(activeStatus2);
  console.log("activeStatus2===>", activeStatus);
  if (activeStatus2 == "Active") {
    steplist = steplist.filter(
      (item) => item !== "Charged-Off" && item !== "Voided"
    );
    return (
      <>
        <Box sx={{ width: "98%", paddingRight: "2%" }}>
          <ActiveOKSlider
            valueLabelDisplay="auto"
            aria-label="pretto slider"
            aria-labelledby="non-linear-slider"
            value={activePaid}
            min={0}
            step={1}
            max={100}
            marks={marks}
          />
        </Box>
      </>
    );
  } else if (activeStatus2 == "Late") {
    return (
      <>
        <Box sx={{ width: "98%", paddingRight: "2%" }}>
          <ActiveLateSlider
            valueLabelDisplay="auto"
            aria-label="pretto slider"
            aria-labelledby="non-linear-slider"
            value={activePaid}
            min={0}
            step={1}
            max={100}
            marks={marks}
          />
        </Box>
      </>
    );
  }
  if (activeStatus2 == "Paid-Off") {
    return (
      <>
        <Box sx={{ width: "98%", paddingRight: "2%" }}>
          <ActivePaidOffSlider
            valueLabelDisplay="auto"
            aria-label="pretto slider"
            aria-labelledby="non-linear-slider"
            value={activePaid}
            min={0}
            step={1}
            max={100}
            marks={marks}
          />
        </Box>
      </>
    );
  } else if (activeStatus2 == "Charged-Off") {
    return (
      <>
        <Box sx={{ width: "100%" }}>
          <ActiveChargedOffSlider
            valueLabelDisplay="auto"
            aria-label="pretto slider"
            aria-labelledby="non-linear-slider"
            value={activePaid}
            min={0}
            step={1}
            max={100}
            marks={marks}
          />
        </Box>
      </>
    );
  } else if (activeStatus2 == "Voided") {
    return (
      <>
        <Box sx={{ width: "100%" }}>
          <ActiveVoidedSlider
            valueLabelDisplay="auto"
            aria-label="pretto slider"
            aria-labelledby="non-linear-slider"
            value={activePaid}
            min={0}
            step={1}
            max={100}
            marks={marks}
          />
        </Box>
      </>
    );
  }

  const AppStatusStepNum = activeStatus2 ? steplist.indexOf(activeStatus2) : 0;
  return (
    <Box sx={{ width: "100%", height: "120px" }}>
      <Stepper activeStep={AppStatusStepNum} alternativeLabel>
        {steplist.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}> {label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

const CustomAttentionField = ({ ...props }) => {
  const record = props.record;
  if (record == null) {
    return null;
  }
  const transferFailedNumber = record.loan.transferFailedNumber;
  const insufficientBalanceCheckNumber =
    record.loan.insufficientBalanceCheckNumber;
  const transferFatalErrorNumber = record.loan.transferFatalErrorNumber;

  let textcolor = "textSecondary";

  let errorValue = [];
  if (transferFailedNumber >= 2) {
    errorValue.push("Transfer Failed");
  }
  if (insufficientBalanceCheckNumber >= 2) {
    errorValue.push("Insufficient Balance");
  }
  if (transferFatalErrorNumber >= 1) {
    errorValue.push("Funding Source Removed");
  }
  if (errorValue.length == 0) {
    return (
      <Typography variant="body2" sx={{ mb: 1, color: "black" }}>
        N/A
      </Typography>
    );
  } else {
    return (
      <Typography variant="body2" sx={{ mb: 1, color: "red" }}>
        {errorValue.map((item, index) => (
          <span key={index}>
            {item}
            {index !== errorValue.length - 1 ? <br /> : ""}
          </span>
        ))}
      </Typography>
    );
  }
};
const LoanStepsHeader = ({ ...props }) => {
  const paramAppId = props.appId;
  let appId = "";
  let record = props.record;
  let loan = record.loan;
  if (loan == undefined || loan == null || loan == "") {
    return <></>;
  }
  let activePaid = 0;
  if (loan.loanStatus == "Paid-Off") {
    activePaid = 100;
  } else if (loan.loanStatus == "Voided") {
    activePaid = 0;
  } else {
    activePaid = loan.hadPaid;
  }

  const CustomModifyStatusText = ({ ...props }) => {
    let statusColor = "black";
    const activeStatus = props.activeStatus;
    if (activeStatus == "OK") {
      statusColor = "#1976d2";
    } else if (activeStatus == "Late" || activeStatus == "30D") {
      statusColor = "orange";
    } else if (activeStatus == "60D" || activeStatus == "90D") {
      statusColor = "red";
    }
    return <span style={{ color: statusColor }}>{props.activeStatus}</span>;
  };
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={2} sx={{ textAlign: "center" }}>
          <Typography variant="h6" align="center" className="hm-menu">
            Status
          </Typography>
          <CustomModifyStatusText activeStatus={record.loan.curStatus} />
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h6" align="center" className="hm-menu">
            Attention
            <br />
            <CustomAttentionField record={record} />
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h6" align="center" className="hm-menu">
            Resets
            <br />
            <span className="numericText">{record?.loan?.allModifyNum}</span>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6" align="center" className="hm-menu">
            Principal Balance Paid
          </Typography>
          <LoanStatusSteps
            activeStatus={
              record.loan.loanStatus ? record.loan.loanStatus : "Active"
            }
            activePaid={activePaid}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default LoanStepsHeader;
